import { useCallback, useState } from 'react';

import { SyncLoader } from 'react-spinners';
import { Background } from 'shared/constants/backgrounds';
import { DivProps } from '../../../../../../typings';
import BackgroundSelection from './background-selection';
import LogoView from './logo-view';
import { MainBlock } from './styles';

type IProps = DivProps & {
  img?: string;
  background?: Background;
  backgroundsList: Background[];
  isLoading?: boolean;
  onChangeBackground?: (background: Background) => void;
};

function BackgroundLogo(props: IProps) {
  const { img, background, isLoading, onChangeBackground, backgroundsList, ...rest } = props;
  const [isEdit, setIsEdit] = useState(false);

  const onSubmit = useCallback(
    (background: Background) => {
      setIsEdit(false);
      onChangeBackground?.(background);
    },
    [onChangeBackground],
  );

  const onCancel = () => {
    setIsEdit(false);
  };

  return !isLoading ? (
    img ? (
      <MainBlock {...rest}>
        {isEdit ? (
          <BackgroundSelection onSubmit={onSubmit} onCancel={onCancel} backgrounds={backgroundsList} img={img} />
        ) : (
          <LogoView onClick={() => setIsEdit(true)} colorName={background?.name ?? ''} color={background?.value ?? ''} img={img} />
        )}
      </MainBlock>
    ) : null
  ) : (
    <SyncLoader />
  );
}

export default BackgroundLogo;
